import React from "react";
import { SALES_STAGES } from "../../constants";

const PlatformStageTag = ({ stageKey }) => {
    const stage = SALES_STAGES.find(s => s.key === stageKey) || { label: stageKey };
    return (
        <span className={`badge rounded crm-stage-badge stage-${stageKey}`}>
            {stage.label}
        </span>
    );
};

export default PlatformStageTag;
